/* eslint-disable no-use-before-define */
import {css} from '@emotion/core'
import {mediaQueries} from '../twd'

export const sectionCss = css`
    background-color: #ffffff;
    ${mediaQueries.notXs} {
        padding: 0 20px;
    }
`


// WEBPACK FOOTER //
// ./src/municipals/style.js